// ----------------------------------------------------------------------
// Sky blue used for all input focus highlights (theme primary is green)
const INPUT_FOCUS_SKY_BLUE = '#0ea5e9';
const INPUT_FOCUS_SKY_BLUE_HOVER = '#0284c7';

// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled }
          }
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiInput-underline::after': {
            borderBottomColor: INPUT_FOCUS_SKY_BLUE
          }
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56]
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: INPUT_FOCUS_SKY_BLUE_HOVER
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[500_12],
          '&:hover': {
            backgroundColor: theme.palette.grey[500_16]
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.focus
          },
          '&.Mui-focused .MuiFilledInput-underline::after': {
            borderBottomColor: INPUT_FOCUS_SKY_BLUE
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground
          }
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56]
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: INPUT_FOCUS_SKY_BLUE_HOVER
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[500_32]
          },
          '&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
            borderColor: INPUT_FOCUS_SKY_BLUE_HOVER
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: INPUT_FOCUS_SKY_BLUE,
            borderWidth: '2px'
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground
            }
          }
        }
      }
    }
  };
}
